import { Flex, Loader } from '@mantine/core';
import cn from 'classnames';
import * as React from 'react';

import Text from 'components/shared/Text';

import s from './StatusUnique.module.scss';

type StatusUniqueProps = {
  isUnique: boolean | null;
  isLoading: boolean;
  className?: string;
};

const StatusUnique: React.FC<StatusUniqueProps> = ({ isUnique, isLoading, className }) => {
  if (isLoading) {
    return (
      <Flex gap="xxs" align="center" px="sm" py="xxxs" justify="center" className={cn(s.statusUnique, className)}>
        <Loader size="xs" color="var(--mantine-color-gray-6)" />
        <Text color="var(--mantine-color-gray-6)" component="p" className={s.text}>
          ПРОВЕРКА
        </Text>
      </Flex>
    );
  }

  if (isUnique === null) {
    return null;
  }

  return (
    <Flex px="sm" py="xxxs" className={cn(s.statusUnique, isUnique ? s.unique : s.notUnique, className)}>
      <Text
        className={s.text}
        component="p"
        color={isUnique ? 'var(--mantine-color-teal-6)' : 'var(--mantine-color-red-6)'}
      >
        {isUnique ? 'УНИКАЛЬНЫЙ' : 'НЕ УНИКАЛЬНЫЙ'}
      </Text>
    </Flex>
  );
};

export default StatusUnique;
